import { UIElement } from "../ui-element.js";
//#region src/ui/status-indicator/value.ts
var StatusIndicatorValueElement = class extends UIElement {
	static {
		this.tagName = "media-status-indicator-value";
	}
};
//#endregion
export { StatusIndicatorValueElement };

//# sourceMappingURL=value.js.map